import type { FaireProductEntity } from "../../entity_types/product";

export const p_syzgfdubef: FaireProductEntity = {
  token: "p_syzgfdubef",
  type: "product",
  name: "Cowboy Boot Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a158b8b1f5c6aae4b0fd8381d579cb715e0f3dce7838d8b78e5d49f4c57f757c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6af0334f94a1ac44efe6a6afe3dd040de76321026794402bd81bfcbf193c3fab.jpeg",
    "https://cdn.faire.com/fastly/aab904abd713c313741ea4626da49822bc4ef4cc46bb3d8fdde95199d6ae10e1.jpeg",
    "https://cdn.faire.com/fastly/4829fbe7a7e2e336bc9441f687ac1a5f6cd2e380a451bc2020ad953c055bbc23.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:02.319Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
